export default "__VITE_ASSET__6ee00aaf__"